import React from 'react'

const { Provider, Consumer } = React.createContext()

class ModalProvider extends React.Component {
  constructor(props) {
    super(props)

    this.open = (path, data) => this.setState(prevState => ({ current: path, data: data || {}, visible: true }))
    this.close = () => this.setState(prevState => ({ current: null, data: {}, visible: false }))

    this.state = {
      visible: false,
      current: null,
      data: {},

      open: this.open,
      close: this.close,
    }
  }

  render() {
    return (
      <Provider value={this.state}>
        {this.props.children}
      </Provider>
    )
  }
}

const withModal = Component => props => (
  <Consumer>
    {state => <Component modal={state} {...props} />}
  </Consumer>
)

export {
  ModalProvider,
  Consumer as ModalConsumer,
  withModal,
}
